// samples

import en from 'ui/assets/img/languages-flags/en.png';
import it from 'ui/assets/img/languages-flags/it.png';
import de from 'ui/assets/img/languages-flags/de.png';
import fr from 'ui/assets/img/languages-flags/fr.png';
import es from 'ui/assets/img/languages-flags/es.png';

import i18next from 'i18next';

export const FontBase = 14;
export const NavBarwidth = 109;

export const fallbackCenterMap = {
  lng: parseFloat(12.90431),
  lat: parseFloat(42.713342)
};

export const GOOGLE_MAPS_KEY = {
  LOCAL: 'AIzaSyDw2ZC36B8ZgevAqQ7KoEf4u9DyWmdI__Y',
  SIT: 'AIzaSyCVYsSKhGnqVvaaA08EQ3iWFi7V4xZF5tY',
  PRE_PROD: 'AIzaSyCVYsSKhGnqVvaaA08EQ3iWFi7V4xZF5tY',
  PROD: 'AIzaSyCVYsSKhGnqVvaaA08EQ3iWFi7V4xZF5tY'
};

export const chargerStatusOptions = [
  {
    value: 'Available',
    label: 'Available'
  },
  {
    value: 'Charging',
    label: 'Charging'
  },
  {
    value: 'Preparing',
    label: 'Preparing'
  },
  {
    value: 'Finishing',
    label: 'Finishing'
  },
  {
    value: 'Unavailable',
    label: 'Unavailable'
  },
  {
    value: 'SuspendedEV',
    label: 'Suspended EV'
  },
  {
    value: 'SuspendedEVSE ',
    label: 'Suspended EVS '
  },
  {
    value: 'Faulted',
    label: 'Faulted'
  },
  {
    value: 'Disconnected',
    label: 'Disconnected'
  }
];

export const sessionFields = [
  'sessionId',
  'event',
  'startTime',
  'endTime',
  'kwh',
  'startType',
  'rfidNumber',
  'userId'
];

export const PageSizeOptions = [
  {
    value: 10,
    label: 10
  },
  {
    value: 25,
    label: 25
  },
  {
    value: 50,
    label: 50
  }
];

export const privateCpDetailTabs = [
  { label: 'At a Glance', value: 'at_a_glance' },
  { label: 'Details', value: 'details' },
  { label: 'Monitoring', value: 'monitoring' },
  { label: 'Users', value: 'users' },
  { label: 'Firmware', value: 'firmware' },
  { label: 'Configurations', value: 'configurations' }
];

export const fotaSubmittedDraft = [
  { label: 'Submitted', value: 'submitted' },
  { label: 'Draft', value: 'draft' }
];

export const StatusTypes = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING',
  AVAILABLE: 'AVAILABLE',
  INSTALLED: 'INSTALLED',
  SOLVED: 'SOLVED'
};

export const StatusLead = {
  NEW: 'new',
  FOLLOW_UP: 'follow_up',
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not_interested',
  TECHNICAL_CALL: 'technical_call',
  COMMERCIAL_CALL: 'commercial_call',
  QUOTATION: 'quotation',
  CLOSED: 'closed',
  CONVERTIBLE: 'convertible',
};

export const StatusLeadFromBe = {
  NEW: 'new',
  FOLLOW_UP: 'follow up',
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not interested'
};

export const StatusLeadOptions = () => {
  return [
    { label: `${i18next.t('new').toUpperCase()}`, value: 'NEW' },
    { label: `${i18next.t('follow_up').toUpperCase()}`, value: 'FOLLOW_UP' },
    { label: `${i18next.t('interested').toUpperCase()}`, value: 'INTERESTED' },
  
    {
      label: `${i18next.t('technical_call').toUpperCase()}`,
      value: 'Technical Call'
    },
    {
      label: `${i18next.t('commercial_call').toUpperCase()}`,
      value: 'Commercial Call'
    },
    {
      label: `${i18next.t('quotation').toUpperCase()}`,
      value: 'Quotation'
    },
    {
      label: `${i18next.t('closed').toUpperCase()}`,
      value: 'NOT_INTERESTED'
    },
    {
      label: `${i18next.t('convertible').toUpperCase()}`,
      value: 'Convertible'
    },
   
  ];
};

export const TypeLeadOptions = () => {
  return [
    { label: `${i18next.t('business').toUpperCase()}`, value: 'Business' },
    { label: `${i18next.t('private').toUpperCase()}`, value: 'Person' }
  ];
};

export const FieldTypes = {
  USER_ID: 'userid',
  ACTIVATION_DATE: 'activationdate',
  RFID_NUMBER: 'rfidnumber',
  STATUS: 'status',
  LAST_USAGE: 'lastusage',
  ID_TAG: 'idtag'
};

export const StatusOperations = {
  ACTIVATE: 'ACTIVATE',
  SUSPEND: 'SUSPEND',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
  DELETE: 'DELETE',
  CHANGEROLE: 'CHANGE ROLE',
  RESEND_EMAIL: 'RESEND_EMAIL'
};

export const ApiStatus = {
  success: 'Success',
  error: 'Error'
};

export const privateStatusOrder = {
  availableStautusNumber: 0,
  chargingStatusNumber: 0,
  faultStatusNumber: 0,
  disconnectedStatusnumber: 0,
  preparingStatusNumber: 0,
  finishingStatusNumber: 0,
  suspendedEVStatusNumber: 0,
  suspendedEVSEStatusNumber: 0,
  unavailableStatusNumber: 0
};

export const ocppParameters = [
  'AllowOfflineTxForUnknownId',

  'AuthorizationCacheEnabled',

  'AuthorizeRemoteTxRequests',

  'BlinkRepeat',

  'ClockAlignedDataInterval',

  'ConnectionTimeOut',

  'GetConfigurationMaxKeys',

  'HeartbeatInterval',

  'LightIntensity',

  'LocalAuthorizeOffline',

  'LocalPreAuthorize',

  'MaxEnergyOnInvalidId',

  'MeterValuesAlignedData',

  'MeterValuesAlignedDataMaxLength',

  'MeterValuesSampledData',

  'MeterValuesSampledDataMaxLength',

  'MeterValueSampleInterval',

  'MinimunStatusDuration',

  'NumberOfConnectors',

  'ResetRetries',

  'ConnectorPhaseRotation',

  'ConnectorPhaseRotationMaxLength',

  'StopTransactionOnEVSideDisconnect',

  'StopTransactionOnInvalidId',

  'StopTxnAlignedData',

  'StopTxnAlignedDataMaxLength',

  'StopTxnSampledData',

  'StopTxnSampledDataMaxLength',

  'SupportedFeatureProfiles',

  'SupportedFeatureProfilesMaxLength',

  'TransactionMessageAttempts',

  'TransactionMessageRetryInterval',

  'UnlockConnectorOnEVSideDisconnect',

  'WebSocketPingInterval',

  'LocalAuthListEnabled',

  'LocalAuthListMaxLength',

  'SendLocalListMaxLength',

  'ReserveConnectorZeroSupported',

  'ChargeProfileMaxStackLevel',

  'ChargingScheduleAllowedChargingRateUnit',

  'ChargingScheduleMaxPeriods',

  'ConnectorSwitch3to1PhaseSupported',

  'MaxChargingProfilesInstalled',
  'AutoStart'
];

export const StatusOptions = () => {
  return [
    { label: `${i18next.t('enabled').toUpperCase()}`, value: 'ENABLED' },
    { label: `${i18next.t('disabled').toUpperCase()}`, value: 'DISABLED' },
    { label: `${i18next.t('pending').toUpperCase()}`, value: 'PENDING' }
  ];
};

export const RfidStatusOptions = [
  {
    value: 'ENABLED',
    label: 'Enabled'
  },
  {
    value: 'DISABLED',
    label: 'Disabled'
  }
];

export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
};

export const RowIDStatus = {
  CREATED: 'CREATED',
  SKIPPED: 'SKIPPED',
  INVALID: 'INVALID'
};

export const FileStatus = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  WARNING: 'WARNING',
  INPROGRESS: 'INPROGRESS'
};
/* Hour range in charts and graphs  */

export const chartHoursRange = [
  '8-12',
  '12-16',
  '16-20',
  '20-24',
  '24-4',
  '4-8'
];

export const statusConnectorCorporate = {
  AVAILABLE: 'available',
  CHARGING: 'charging',
  WAITING_FOR_APPROVAL: 'waiting for approval',
  UNAVAILABLE: 'unavailable',
  RESERVED: 'reserved'
};

export const alertsStatus = {
  SOLVED: 'SOLVED',
  UNSOLVED: 'UNSOLVED'
};

export const alertTypes = {
  ALARM: 'Alarm',
  WARNING: 'Warning'
};

export const alertsStatusOptions = [
  {
    value: 'SOLVED',
    label: 'Solved'
  },
  {
    value: 'UNSOLVED',
    label: 'Unsolved'
  }
];

export const alertsTypesOptions = [
  {
    value: 'Alarm',
    label: 'Alarm'
  },
  {
    value: 'Warning',
    label: 'Warning'
  }
];

export const errorCodesFromBE = {
  FAILED_UPDATE: 'FailedUpdate',
  NO_POWER: 'NoPower',
  NO_RESPONSE: 'NoResponse'
};

export const errorCodesForFE = {
  SOFTWARE_ISSUE: 'Software issue',
  HARDWARE_ISSUE: 'Hardware issue',
  CONNECTION_ISSUE: 'Connection issue'
};

export const errorCodesCluster = {
  [errorCodesForFE.SOFTWARE_ISSUE]: [errorCodesFromBE.FAILED_UPDATE],
  [errorCodesForFE.HARDWARE_ISSUE]: [errorCodesFromBE.NO_POWER],
  [errorCodesForFE.CONNECTION_ISSUE]: [errorCodesFromBE.NO_RESPONSE]
};

export const errorCodesForSelect = [
  {
    value: errorCodesForFE.CONNECTION_ISSUE,
    label: errorCodesForFE.CONNECTION_ISSUE
  },
  {
    value: errorCodesForFE.SOFTWARE_ISSUE,
    label: errorCodesForFE.SOFTWARE_ISSUE
  },
  {
    value: errorCodesForFE.HARDWARE_ISSUE,
    label: errorCodesForFE.HARDWARE_ISSUE
  }
];

export const fieldsForDiagnostics = [
  'startDate',
  'endDate',
  'status',
  'timestamp',
  'solvedTimestamp',
  'chargePointId',
  'eventType',
  'errorCode',
  'description'
];

export const fieldsLastCampaign = [
  'campaignStatus',
  'campaignId',
  'campaignName',
  'totCPtoUpdate',
  'totCPupdated',
  'lastUpdateDate',
  'lastUpdateDate',
  'endDate'
];

export const fieldsCampaigns = [
  'campaignStatus',
  'campaignId',
  'campaignName',
  'totCPtoUpdate',
  'totCPupdated',
  'campaignType',
  'startDate',
  'firmwareVersion',
  'lastUpdateDate',
  'campaignCreator'
];
export const fieldsFirmwares = [
  'firmwareId',
  'fwName',
  'modelsCompatible',
  'firmwareCompatibility',
  'URL',
  'usedInCampain'
];

export const campaignStatus = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  DRAFT: 'DRAFT',
  STOPPED: 'STOPPED'
};

export const campaignType = {
  NOT_PAIRED: 'NOT_PAIRED',
  PAIRED: 'PAIRED',
  TEST: 'TEST'
};

/*
 * ---------
 * PARTNER
 * ---------
 * */

export const brandsVehicle = () => [
  { value: 'Jeep', label: 'Jeep' },
  { value: 'Fiat', label: 'Fiat' },
  { value: 'Peugeot', label: 'Peugeot' },
  { value: 'Citroën', label: 'Citroën' },
  { value: 'Opel', label: 'Opel' },
  { value: 'DS', label: 'DS' },
  { value: 'Alfa Romeo', label: 'Alfa Romeo' },
  { value: 'Maserati', label: 'Maserati' },
  { value: 'Abarth', label: 'Abarth' },
  { value: 'Lancia', label: 'Lancia' },
  { value: 'Other', label: i18next.t('other') }
];

export const partnerRoles = {
  ADMIN: 'PartnerPortalAdmin',
  COMMERCIAL_PARTNER_USER: 'BusinessUser',
  COMMERCIAL_PARTNER_SUPER_USER: 'BusinessAdmin',
  TECHNICAL_PARTNER_USER: 'TechnicalUser',
  TECHNICAL_PARTNER_SUPER_USER: 'TechnicalAdmin',
  SYSTEM_ADMIN: 'SystemAdmin'
};

/*export const partnerRoleOptions = () => [
  {
    value: 'PartnerPortalAdmin',
    label: 'Partner Portal Admin'
  },
  {
    value: 'BusinessAdmin',
    label: 'Commercial Admin'
  },
  {
    value: 'BusinessUser',
    label: 'Commercial User'
  },
  {
    value: 'TechnicalAdmin',
    label: 'Technical Admin'
  },
  {
    value: 'TechnicalUser',
    label: 'Technical User'
  }
];*/

export const partnerRoleOptions = () => {
  return [
    {
      label: `${i18next.t('partner_portal_admin').toUpperCase()}`,
      value: 'PartnerPortalAdmin'
    },
    {
      label: `${i18next.t('business_admin').toUpperCase()}`,
      value: 'BusinessAdmin'
    },
    {
      label: `${i18next.t('business_user').toUpperCase()}`,
      value: 'BusinessUser'
    },
    {
      label: `${i18next.t('technical_admin').toUpperCase()}`,
      value: 'TechnicalAdmin'
    },
    {
      label: `${i18next.t('technical_user').toUpperCase()}`,
      value: 'TechnicalUser'
    }
  ];
};

export const rolesForTranslations = {
  PartnerPortalAdmin: 'partner_portal_admin',
  BusinessAdmin: 'business_admin',
  BusinessUser: 'business_user',
  TechnicalAdmin: 'technical_admin',
  TechnicalUser: 'technical_user'
};

export const adminRoles = [
  'PartnerPortalAdmin',
  'BusinessAdmin',
  'TechnicalAdmin'
];

export const commercialRoles = ['BusinessAdmin', 'BusinessUser'];

export const technicalRoles = ['TechnicalAdmin', 'TechnicalUser'];

/*
 * ---------
 * LANGUAGES
 * ---------
 * */

export const languages = () => [
  { code: 'en', flag: en, label: i18next.t('english') },
  { code: 'it', flag: it, label: i18next.t('italian') },
  { code: 'de', flag: de, label: i18next.t('german') },
  { code: 'fr', flag: fr, label: i18next.t('french') },
  { code: 'es', flag: es, label: i18next.t('spanish') } //flag to be changed
];

/*
 * ---------
 * LEAD DETAIL MAP
 * ---------
 * */

export const leadDetailFieldsReadonly = {
  Business: ['company_legal_name', 'email_placeholder'],
  Person: ['name', 'surname', 'name_surname', 'email_placeholder', 'company']
};
export const cognitoErrors = {
  CodeMismatchException: 'wrong_otp_error',
  LimitExceededException: 'limit_exceeded_error'
};

export const leadFieldsForBe = {
  Building__c: 'building_or_place_called',
  Car_Brand__c: 'car_brand',
  City: 'city',
  Company: 'company',
  Company_Legal_Name__c: 'company_legal_name',
  Company_ValueAddedTax__c: 'vat_number',
  Country: 'country',
  Email: 'email_placeholder',
  FirstName: 'name',
  Fiscal_Code__c: 'fiscal_code',
  LastName: 'surname',
  MobilePhone: 'secondary_phone',
  Name_of_the_Dealer__c: 'name_of_dealer',
  Phone: 'phone_number',
  PostalCode: 'zip',
  Prefix_Secondary_Phone__c: 'prefix_secondary_phone',
  Prefix__c: 'prefix',
  Product_of_Interest__c: 'product_preferences_placeholder',
  RecordType: 'record_type',
  Street: 'street',
  Type_of_Vehicle__c: 'vehicle_type',
  Vehicle_Delivery__c: 'delivery_date',
  Vehicle_Identification_Number__c: 'vin',
  Note__c: 'notes'
};

export const StatusForHistory = {
  Closed: 'not_interested',
  'Follow Up': 'follow_up',
  Interested: 'interested',
  New: 'new',
  Quotation: 'quotation',
  'Technical Call': 'technical_call',
  'Commercial Call': 'commercial_call'
};

export const isReadOnly = (
  isTextarea,
  role,
  creatorEmail,
  userEmail,
  leadStatus
) => {
  if (isTextarea) {
    if (role === 'BusinessAdmin') {
      return false;
    } else if (role === 'BusinessUser' && creatorEmail === userEmail) {
      return false;
    } else {
      return true;
    }
  } else {
    if (role === 'BusinessAdmin' && leadStatus === StatusLead.NEW) {
      return false;
    } else if (
      role === 'BusinessUser' &&
      leadStatus === StatusLead.NEW &&
      creatorEmail === userEmail
    ) {
      return false;
    } else {
      return true;
    }
  }
};

export const IDENTIFIER_NEW_PRODUCT_PREFERENCE_NUMBER =
  'IDENTIFIER_NEW_PRODUCT_PP_TO_BE_DELETED';
